import React from 'react';

const About = () => {
    return (
        <div className="container-width py-16">
        <h1 className="text-4xl font-bold mb-8">About Us</h1>
        <p className="text-lg text-gray-600 mb-4">
        We are Microsoft 365 migration specialists with over a decade of experience
        in enterprise tenant migrations.
        </p>
        <p className="text-lg text-gray-600">
        Our team ensures seamless transitions with zero data loss and minimal
        business disruption.
        </p>
        </div>
    );
};

export default About;
